<template>
  <span v-if="value" class="duration">
    {{displayValue}} {{displayUnit}}
  </span>
</template>

<script>
import camelCase from 'lodash/camelCase';

export default {
  name: 'duration',
  props: {
    value: Object,
  },
  computed: {
    displayValue() {
      return this.value.value;
    },
    displayUnit() {
      const unit = camelCase(this.value.unit);
      return this.$t(`units.duration.${unit}`);
    },
  },
};
</script>



// WEBPACK FOOTER //
// Duration.vue?3b8a9b2a